//**** REACT
import React, { useContext } from "react";
// *** Services

// *** Core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// import TextField from "@material-ui/core/TextField";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import Checkbox from "@material-ui/core/Checkbox";
// import Check from "@material-ui/icons/Check";
// import { Link } from "react-router-dom";
// *** Contexto
import { UsuarioContext } from "config/context/UsuarioProvider";
// *** Imagenes
import imgFinCompra from "assets/img/com-fes/img-fin-compra.png";
import imgFinCompraFea from "assets/img/com-fea/img-fin-compra.png";
// *** @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.js";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
const useStyles = makeStyles(basicsStyle);
const useStyles2 = makeStyles(featuresStyle);

export default function ValidacionFinalDatos() {
  const { usuario, setusuario, planUser } = useContext(UsuarioContext);
  const classes2 = useStyles2();
  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <div className={classes2.features3}>
            {planUser === "CFES" ? (
              <img src={imgFinCompra} alt="..." />
            ) : (
              <img src={imgFinCompraFea} alt="..." />
            )}
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.title} style={{ textAlign: "center" }}>
                <h3 style={{fontWeight: "400"}}>Compra finalizada</h3>
              </div>
              <div style={{ paddingTop: 2 }}></div>
              {planUser === "CFES" ? (
                <div className={classes.title} style={{ textAlign: "justify" }}>
                  <h4>
                  Estimado cliente, ha culminado con éxito la compra del producto FIRMA SIMPLE.
                  Para descargar el certificado seleccione el botón "Descargar" y siga las instrucciones enviadas por correo o presione el botón Finalizar para culminar el
                  proceso.
                  </h4>
                </div>
              ) : (
                <div className={classes.title} style={{ textAlign: "justify" }}>
                  <h4>
                  Estimado cliente, ha culminado con éxito la compra de FIRMA AVANZADA.
                  Para completar el proceso presione el botón Finalizar.
                  Para obtener su token, uno de nuestros ejecutivos se pondrá en contacto
                  dentro de las próximas 20 horas hábiles o puede acercarse a
                  nuestras oficinas ubicadas en Fanor Velasco N° 85, piso 3.
                  </h4>
                </div>
              )}
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
